import * as SentryReact from "@sentry/react";
import config from "@src/config";
import { useUser } from "@vivid/react-oidc-client";
import { type FunctionComponent, type PropsWithChildren, useEffect } from "react";

export const Sentry: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const user = useUser();

    useEffect(() => {
        const options: SentryReact.BrowserOptions = {
            dsn: config.ADMIN_SENTRY_DSN,
            integrations: [SentryReact.browserTracingIntegration()],
            environment: config.SENTRY_ENV,
            tracesSampleRate: 0.1,
        };
        if (process.env.NODE_ENV !== "development") {
            SentryReact.init(options);
        } else {
            // eslint-disable-next-line no-console
            console.log(`Sentry is disabled in NODE_ENV === ${process.env.NODE_ENV} `);
        }
    }, []);

    useEffect(() => {
        const sentryUser = { ...user, id: user?.sub };
        SentryReact.setUser(sentryUser);
    }, [user]);

    SentryReact.setTags({
        buildNumber: config.BUILD_NUMBER,
        commitSHA: config.COMMIT_SHA,
        commitLastDate: config.COMMIT_LAST_DATE,
        buildDate: config.BUILD_DATE,
    });

    return <>{children}</>;
};
